module.exports = __webpack_public_path__ + "static/WEDDING E&M-30-601ffc14a56572c120bda84107ad9291.jpg";